import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-mentionlegal',
  templateUrl: './mentionlegal.component.html',
  styleUrls: ['./mentionlegal.component.scss']
})
export class MentionlegalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
